import { render, staticRenderFns } from "./AdminOnlyNote.vue?vue&type=template&id=78b4ce6c&scoped=true&"
import script from "./AdminOnlyNote.vue?vue&type=script&lang=js&"
export * from "./AdminOnlyNote.vue?vue&type=script&lang=js&"
import style0 from "./AdminOnlyNote.vue?vue&type=style&index=0&id=78b4ce6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b4ce6c",
  null
  
)

export default component.exports